import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Notification
export const getNotificationsWaiterService = (params) => {
  return http.get(`${base_url}/waiter/notification`, { params });
};
export const deleteAllNotificationWaiterService = () => {
  return http.delete(`${base_url}/waiter/notification`);
};
export const deleteNotificationWaiterService = (id) => {
  return http.delete(`${base_url}/waiter/notification/${id}`);
};
// End Notification
